import { parsePhoneNumber, isValidPhoneNumber, CountryCode } from 'libphonenumber-js';

/**
 * Validates phone numbers using Google's libphonenumber-js library
 * Accepts international formats with proper country codes
 * - +1 555 123 4567 (US)
 * - +44 20 7946 0958 (UK)
 * - (555) 123-4567 (assumes US if no country code)
 * - 555-123-4567 (assumes US if no country code)
 */
export function isValidPhone(phone: string, defaultCountry: CountryCode = 'US'): boolean {
  if (!phone || typeof phone !== 'string') return false;
  
  try {
    // Try to validate with the default country
    return isValidPhoneNumber(phone, defaultCountry);
  } catch (error) {
    // If parsing fails, return false
    return false;
  }
}

export function formatPhoneForDisplay(phone: string, defaultCountry: CountryCode = 'US'): string {
  if (!phone) return '';
  
  try {
    const phoneNumber = parsePhoneNumber(phone, defaultCountry);
    // Return in international format if valid
    return phoneNumber ? phoneNumber.formatInternational() : phone;
  } catch (error) {
    // If parsing fails, return original
    return phone;
  }
}

export function normalizePhone(phone: string, defaultCountry: CountryCode = 'US'): string | null {
  if (!phone) return null;
  
  try {
    const phoneNumber = parsePhoneNumber(phone, defaultCountry);
    // Return in E.164 format (e.g., +15551234567) for database storage
    return phoneNumber ? phoneNumber.number : null;
  } catch (error) {
    return null;
  }
}

export const PHONE_VALIDATION_ERROR = 'Please enter a valid phone number with area code (e.g., (555) 123-4567 or +1 555 123 4567)';
